import { Button, Grid, Hidden, Step, StepLabel, Stepper, styled } from '@mui/material';
import { CustomCheckbox, CustomCheckboxGroup } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomGrouping';
import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraComprimentoMinimo from 'esocial.web.react.lib/cjs/components/form/Validation/RegraComprimentoMinimo';
import RegraCpf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCpf';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { limparMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { getStringValue, isUndefinedOrNull, obterObjetoTodosComponentesTocados, rolarVisualizacaoAteElemento, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Exames from './Exames';

const BackButton = styled(Button)(({ theme }) => ({
    marginRight: theme.spacing(1),
}));

const StepButtonsBox = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "space-between"
}));

function MonitoramentoSaudeRegistro({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [preencherInformacoesGrupoRespMonit, setPreencherInformacoesGrupoRespMonit] = useState(false);

    // Hook personalizado para requisições ao servidor
    const { get, post } = useRequisicaoControlada();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    //Para o Stepper
    const steps = ['Informações do exame médico ocupacional', 'Exames complementares e avaliações clínicas'];

    const handleNext = (e) => {
        if (activeStep === 1) {
            handleSubmit(e);
        } else {
            setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
            setNomeFuncaoAcaoFormularioCompletamenteValidado('proximo');
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleChangePreencherInformacoesGrupoRespMonit = (e) => {
        setPreencherInformacoesGrupoRespMonit(e.target.checked);

        // Limpar os campos do grupo, se necessário
        if (!e.target.checked) {
            setModelo({
                ...modelo,
                cpfMedicoResponsavel: { ...modelo.cpfMedicoResponsavel, valor: '' },
                nomeMedicoResponsavel: { ...modelo.nomeMedicoResponsavel, valor: '' },
                numeroCRMResponsavel: { ...modelo.numeroCRMResponsavel, valor: '' },
                ufCRMResponsavel: { ...modelo.ufCRMResponsavel, valor: '' }
            });
        }
    };

    function stepValidado(ehValido) {
        if (ehValido) {
            dispatch(limparMensagens());
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    function getStepperButtons(visualizacao) {
        return (
            <StepButtonsBox>
                <Button color="secondary" size="medium" onClick={() => navigate(-1)}>
                    {!visualizacao ? 'Cancelar' : 'Voltar'}
                </Button>

                <div>
                    <BackButton
                        variant="outlined"
                        color="primary"
                        disabled={activeStep < 1}
                        onClick={handleBack}
                    >
                        Anterior
                    </BackButton>

                    <Display show={activeStep !== steps.length - 1}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleNext}>
                            Próximo
                        </Button>
                    </Display>

                    <Display show={!visualizacao && activeStep === steps.length - 1}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                        >
                            Salvar
                        </Button>
                    </Display>
                </div>
            </StepButtonsBox>
        );
    }

    const processamentoResposta = (conteudoResposta) => {
        setModelo(conteudoResposta);

        // Atualizar o estado de preencherInformacoesGrupoRespMonit
        setPreencherInformacoesGrupoRespMonit(getStringValue(conteudoResposta.nomeMedicoResponsavel.valor).length > 0)
    };

    function voltarListagem() {
        navigate(`/monitoramentoSaude/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['tipoExameOcupacional'] = false;
    objetoComponentesTocados['dataASO'] = false;
    objetoComponentesTocados['nomeMedicoASO'] = false;
    objetoComponentesTocados['numeroCRMASO'] = false;
    objetoComponentesTocados['ufCRMASO'] = false;
    objetoComponentesTocados['cpfMedicoResponsavel'] = false;
    objetoComponentesTocados['nomeMedicoResponsavel'] = false;
    objetoComponentesTocados['numeroCRMResponsavel'] = false;
    objetoComponentesTocados['ufCRMResponsavel'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (modelo != null) {
            objetoRegrasValidacao['tipoExameOcupacional'] = new RegraObrigatoriedade(modelo.tipoExameOcupacional.valor, componenteTocadoFormulario['tipoExameOcupacional']);
            objetoRegrasValidacao['dataASO'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataASO.valor), new RegraDiaMesAno(modelo.dataASO.valor)], componenteTocadoFormulario['dataASO']);
            objetoRegrasValidacao['nomeMedicoASO'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.nomeMedicoASO.valor), new RegraComprimentoMinimo(modelo.nomeMedicoASO.valor, 2)], componenteTocadoFormulario['nomeMedicoASO']);
            //objetoRegrasValidacao['numeroCRMASO'] = new RegraObrigatoriedade(modelo.numeroCRMASO.valor, componenteTocadoFormulario['numeroCRMASO']);
            //objetoRegrasValidacao['ufCRMASO'] = new RegraObrigatoriedade(modelo.ufCRMASO.valor, componenteTocadoFormulario['ufCRMASO']);

            // Grupo respMonit opcional (regido por preencherInformacoesGrupoRespMonit)
            objetoRegrasValidacao['cpfMedicoResponsavel'] = new RegraCpf(modelo.cpfMedicoResponsavel.valor, componenteTocadoFormulario['cpfMedicoResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['nomeMedicoResponsavel'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.nomeMedicoResponsavel.valor), new RegraComprimentoMinimo(modelo.nomeMedicoResponsavel.valor, 2)], componenteTocadoFormulario['nomeMedicoResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['numeroCRMResponsavel'] = new RegraObrigatoriedade(modelo.numeroCRMResponsavel.valor, componenteTocadoFormulario['numeroCRMResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['ufCRMResponsavel'] = new RegraObrigatoriedade(modelo.ufCRMResponsavel.valor, componenteTocadoFormulario['ufCRMResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [modelo, componenteTocadoFormulario, preencherInformacoesGrupoRespMonit]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        async function processamentoInternoAssincrono() {
            const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

            if (visualizacao) {
                if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'proximo') {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }
                return;
            }
            if (regraValidacaoFormulario.todosComponentesTocados) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                    if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                        if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter' && !visualizacao) {
                            await post("/sst/monitoramentoSaude/salvar", modelo, voltarListagem, undefined, { mensagensResistentes: true });
                        } else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'proximo') {
                            if (visualizacao) {
                                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                            } else {
                                let exameAuxiliar = modelo.itemExameAuxiliar;
                                exameAuxiliar.dataExame.valor = null;
                                exameAuxiliar.codigoProcedimentoRealizado.valor = '';
                                exameAuxiliar.ordemExame.valor = null;
                                exameAuxiliar.indicacaoResultados.valor = null;
                                exameAuxiliar.observacaoProcedimento.valor = '';

                                setModelo({
                                    ...modelo,
                                    stepAtual: activeStep,
                                    itemExameAuxiliar: exameAuxiliar
                                });
                                //console.log(modelo);
                                await post("/sst/monitoramentoSaude/validarParcial", modelo, stepValidado);
                            }
                        }
                    }
                    else {
                        rolarVisualizacaoAteElementoInvalido();
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        processamentoInternoAssincrono();
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setModelo({
            ...modelo,
            itemExameAuxiliar: {
                dataExame: { ...modelo.itemExameAuxiliar.dataExame, valor: null },
                codigoProcedimentoRealizado: { ...modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: '' },
                ordemExame: { ...modelo.itemExameAuxiliar.ordemExame, valor: null },
                indicacaoResultados: { ...modelo.itemExameAuxiliar.indicacaoResultados, valor: null },
                observacaoProcedimento: { ...modelo.itemExameAuxiliar.observacaoProcedimento, valor: '' }
            }
        });

        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    // Rolar para o início do indicador de passos a cada troca de passo executada
    useEffect(() => {
        rolarVisualizacaoAteElemento('indicador-passos');
    }, [activeStep]);

    async function inicializarModelo(idEvento, idContrato, tsv, admPreliminar) {
        // Registro
        if (isUndefinedOrNull(idEvento)) {
            await get(`sst/monitoramentoSaude/obterEvento/0/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
        // Visualização ou retificação
        else {
            await get(`sst/monitoramentoSaude/obterEvento/${idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
    }

    useEffect(() => {
        inicializarModelo(idEvento, idContrato, tsv, admPreliminar);
    }, []);

    return (
        (modelo !== null && Object.values(regraValidacaoFormulario).length > 0) ?
            <Fragment>
                <TituloPagina>Monitoramento de Saúde</TituloPagina>
                <form id="formMonitoramentoSaude" onSubmit={(e) => handleSubmit(e)}>
                    <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                        <VepTextField
                            accessor="cpfTrabalhador"
                            label="CPF"
                            model={modelo}
                            xs={12} md={3}
                            readOnly
                            maskPattern={Mascara.CPF}
                        />

                        <CustomTextField
                            xs={12} md={6}
                            label="Nome"
                            value={modelo.nome}
                            readOnly />

                        {(!isUndefinedOrNull(modelo.matricula.valor) && modelo.matricula.valor.length > 0) &&
                            <VepTextField
                                accessor="matricula"
                                label="Matrícula"
                                model={modelo}
                                xs={12} md={3}
                                readOnly
                            />
                        }

                        {((isUndefinedOrNull(modelo.matricula.valor) || modelo.matricula.valor.length == 0) &&
                            !isUndefinedOrNull(modelo.codigoCategoria.valor)) &&
                            <CustomTextField
                                label="Categoria"
                                value={modelo.codigoCategoria.fonteDados[modelo.codigoCategoria.valor]}
                                xs={12} md={12}
                                readOnly
                            />
                        }
                    </Fieldset>

                    <Stepper id="indicador-passos" activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {activeStep === 0 &&
                        <Fragment>
                            <Fieldset spacing={4}>
                                <VepSelect
                                    accessor="tipoExameOcupacional"
                                    label="Qual o tipo do exame médico ocupacional?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormulario['tipoExameOcupacional'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'tipoExameOcupacional': true })}
                                />
                            </Fieldset>

                            <Fieldset legend="Dados do Atestado de Saúde Ocupacional (ASO)" spacing={4}>
                                <VepSelect
                                    accessor="resultadoASO"
                                    label="De acordo com o exame o trabalhador está apto?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={5}
                                    readOnly={visualizacao}
                                    emptyOption
                                />

                                <VepDatePicker
                                    accessor="dataASO"
                                    label="Qual a data de emissão do atestado de saúde ocupacional?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={6}
                                    required
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormulario['dataASO'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataASO': true })}
                                />

                                <VepTextField
                                    accessor="nomeMedicoASO"
                                    label="Nome do médico emitente do ASO"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={5}
                                    minLength={2}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormulario['nomeMedicoASO'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'nomeMedicoASO': true })}
                                />

                                <VepTextField
                                    accessor="numeroCRMASO"
                                    label="Número do Conselho Federal de Medicina (CRM)"
                                    model={modelo}
                                    setModel={setModelo}
                                    maxLength={8}
                                    xs={12} md={5}
                                    readOnly={visualizacao}
                                />

                                <VepSelect
                                    accessor="ufCRMASO"
                                    label="UF do CRM"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={2}
                                    readOnly={visualizacao}
                                />
                            </Fieldset>

                            <Fieldset legend="Médico que coordena o Programa de Controle Médico de Saúde Ocupacional - PCMSO" spacing={4}>
                                <Display show={!visualizacao}>
                                    <Grid item style={{ flexBasis: '25%' }}>
                                        <CustomCheckboxGroup md={12} readOnly={visualizacao}>
                                            <CustomCheckbox
                                                label="Preencher informações?"
                                                checked={preencherInformacoesGrupoRespMonit}
                                                onChange={handleChangePreencherInformacoesGrupoRespMonit}
                                                readOnly={visualizacao}
                                            />
                                        </CustomCheckboxGroup>
                                    </Grid>

                                    {/*Offset*/}
                                    <Hidden smDown>
                                        <Grid item style={{ flexBasis: '75%' }} />
                                    </Hidden>
                                </Display>

                                <VepTextField
                                    accessor="cpfMedicoResponsavel"
                                    label="CPF do Médico responsável/coordenador"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    maskPattern={Mascara.CPF}
                                    maxLength={14}
                                    readOnly={visualizacao}
                                    disabled={!preencherInformacoesGrupoRespMonit}
                                    {...regraValidacaoFormulario['cpfMedicoResponsavel'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'cpfMedicoResponsavel': true })}
                                />

                                <VepTextField
                                    accessor="nomeMedicoResponsavel"
                                    label="Nome do médico"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={6}
                                    minLength={2}
                                    required={preencherInformacoesGrupoRespMonit}
                                    readOnly={visualizacao}
                                    disabled={!preencherInformacoesGrupoRespMonit}
                                    {...regraValidacaoFormulario['nomeMedicoResponsavel'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'nomeMedicoResponsavel': true })}
                                />

                                <VepTextField
                                    accessor="numeroCRMResponsavel"
                                    label="Número do Conselho Federal de Medicina (CRM)"
                                    model={modelo}
                                    setModel={setModelo}
                                    maxLength={8}
                                    xs={12} md={5}
                                    required={preencherInformacoesGrupoRespMonit}
                                    readOnly={visualizacao}
                                    disabled={!preencherInformacoesGrupoRespMonit}
                                    {...regraValidacaoFormulario['numeroCRMResponsavel'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'numeroCRMResponsavel': true })}
                                />

                                <VepSelect
                                    accessor="ufCRMResponsavel"
                                    label="UF do CRM"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    required={preencherInformacoesGrupoRespMonit}
                                    readOnly={visualizacao}
                                    disabled={!preencherInformacoesGrupoRespMonit}
                                    {...regraValidacaoFormulario['ufCRMResponsavel'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'ufCRMResponsavel': true })}
                                />
                            </Fieldset>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                    {activeStep === 1 &&
                        <Fragment>
                            <Exames modelo={modelo} setModelo={setModelo} somenteVisualizacao={visualizacao}></Exames>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                </form>
            </Fragment > :
            <ContentPreview />
    );
}

export default MonitoramentoSaudeRegistro;
